var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "face_features"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4F3827",
    d: "M348.6,276.9c0.9,6.8,1.2,14.1,1.1,21c-0.1,6.5-0.6,12.9-2.7,19.1c-0.2,0.6,1,0.7,1.2,0.1 c3-6.6,2.7-13.2,2.9-19.8c0.2-7,0-13.5-1.3-20.3C349.7,275.8,348.5,276.3,348.6,276.9L348.6,276.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4F3827",
    d: "M341.8,329.8c-3.9-3.8-5.3-8.8-1.2-12.9c0.5-0.5-0.2-1.1-0.8-0.8c-4.6,2.9-5.5,10.4,0.9,14.5 C341.2,331.1,342.2,330.8,341.8,329.8L341.8,329.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4F3827",
    d: "M373.3,329.3c-1.8,0.4-3.7,1.6-5.4,2.4c-1.7,0.7-3.5,1.3-5.3,1.8c-4.2,1.1-8.3-0.2-12-2.3 c-0.4-0.2-0.7-0.4-1-0.6c-1.2-1-4.3-2.6-5.7-1.7c-1.1,0.6-1.2,1.9,0,2.2c1,0.3,2,0.4,3,0.4s2.1,0,3,0.4c0.6,0.4,1.2,0.8,1.9,1.1 c2.3,1.2,4.8,1.8,7.4,2c3,0.2,6-1,8.8-2c0.2-0.1,0.5-0.2,0.8-0.4c0.6-0.2,1.1-0.5,1.8-0.6c1-0.2,2.5-0.1,3.5-0.1 C376.8,331.7,376,328.6,373.3,329.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4F3827",
    d: "M377.3,332c7-2.6,8.6-12.3,2.8-16.5c-0.8-0.6-1.3,0.4-0.8,0.9c4.7,4,1.9,11.8-2.6,14.7 C376.2,331.4,376.7,332.3,377.3,332L377.3,332z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EE9271",
    d: "M337.7,358.5c-4.6-1.2-9-2.7-13.4-4.6c-2.6-1.1,2.9-1.2,3.5-1.2c2.4-0.1,4.7-0.4,7.1-0.7 c8.5-1.1,18.3-4.6,26.3,0.4c0.6,0.4,1,0.6,1.6,0.2c0.8-0.5,2.2-1.6,3.2-2.1c2-0.9,5.7-1.2,7.7-1.2c5-0.2,9.6,0,14.6,0 c2.3,0,4.5,0,6.8-0.1c1,0,5.4-0.1,2.3,1.5s-8,3.9-11.3,5c0,0-1,1.7-1.3,2.5c-4.5,9.2-13.7,11.4-21.7,12.4 c-3.7,0.4-11.6,0.1-14.9-1.7C343.1,366.1,340.8,363.3,337.7,358.5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F29A7A",
    cx: 374.5,
    cy: 363,
    rx: 1.5,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C37154",
    d: "M356.8,358.9c-6.4-0.2-12.8-1-19.3-2.5c-1.7-0.4-3.5-0.9-5.2-1.5c-2.2-0.7-4.3-1.4-6.4-2.2 c-1.5,0.1-3.1,0.4-1.5,1.1c4.4,1.9,8.8,3.4,13.4,4.6l0,0c9.4,2.2,22.4,3.2,33.5,1.2c1.6-0.3,3.2-0.6,4.8-0.9 c3.1-0.7,6.8-1.9,9.9-3.1c0-0.1,0.1-0.1,0.1-0.1c2.2-0.7,5.1-2,7.7-3.2c-10,3.6-21.7,6.5-32.2,6.5C360,359,358.4,359,356.8,358.9 z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/_face.95c11723c8e371312124a10d8473539d.svg";
export { ForwardRef as ReactComponent };